export const gitCommit = '954c83e0'
